// UNIVERSAL 4.0 — 57 numbered cutouts, straight off the official marking sheet (u_4.0_scheme_300.jpg),
// in 4 blocks. Face A carries 1–14 and 27–43, face B carries 15–26 and 44–57.
// Positions are card millimetres (mx from the face's left edge, my from its top); est:true = a parked
// guess on a placement grid, replaced the moment a mark is placed in the Explorer.
// BOTH photos are loose fits: inside the card a mm-derived chip lands close, but on the silhouette
// edge (mx 0/85, my 0/55) the error throws it onto the background. So both faces are homApprox and
// carry PHOTO-ONLY marks in ph:{A|B:{x,y}} (percent of the shot) — seeded from the homography so the
// pass starts on the card, then nudged by hand. The mm above, and the 3D markers, never move.
// Face A seeds come from the four card corners measured in the photo (3.4/28.6, 68.2/23.3, 76.8/65.7,
// 10.0/85.2 as % of the shot) by bilinear map, 3% inset. Face B keeps the homography's diamond but
// shrunk 0.85 toward the card's real centre. A ph value in THIS FILE is provisional: only an entry in
// u4_photo_pct1 counts as hand-confirmed, so seeded chips stay dashed and out of the tally.
// LOCKED: 57/57 mm and 54/57 photo positions are hand-placed and carry phOwn:true. The remaining
// 3 (15, 24, 48) are still seeds and stay dashed until placed.
window.U4 = {
 "blocks": [
  {
   "id": "cut",
   "label": "Cut, pry & open",
   "sub": "Blades, levers, openers, scrapers",
   "tools": [
    {
     "cat": "CUT",
     "side": "A",
     "mx": 0,
     "my": 0,
     "name": "Scoring tool",
     "desc": "Hardened point for scribing a line on card, plastic or drywall before the cut.",
     "sc": "Marking a straight line on a box before slicing it open.",
     "n": 1,
     "est": false,
     "ph": {
      "A": {
       "x": 2.1,
       "y": 29
      }
     },
     "phOwn": true
    },
    {
     "cat": "CLEAN",
     "side": "A",
     "mx": 0,
     "my": 43.9,
     "name": "Wide BBQ grill scraper",
     "desc": "Broad scraping edge for grill bars and baked-on residue.",
     "sc": "Cleaning a rental grill before the coals go in.",
     "n": 11,
     "est": false,
     "ph": {
      "A": {
       "x": 8.7,
       "y": 76.3
      }
     },
     "phOwn": true
    },
    {
     "cat": "DRIVE",
     "side": "A",
     "mx": 0,
     "my": 50.8,
     "name": "Flat screwdriver",
     "desc": "Standard flat tip on the card body.",
     "sc": "A battery hatch screw on a travel scale.",
     "n": 12,
     "est": false,
     "ph": {
      "A": {
       "x": 9.1,
       "y": 87.8
      }
     },
     "phOwn": true
    },
    {
     "cat": "OPEN",
     "side": "A",
     "mx": 4.9,
     "my": 49,
     "name": "Can opener",
     "desc": "Hooked lever that walks around a can lid.",
     "sc": "Tinned food in a cabin with no opener in the drawer.",
     "n": 13,
     "est": false,
     "ph": {
      "A": {
       "x": 17.6,
       "y": 83
      }
     },
     "phOwn": true
    },
    {
     "cat": "CUT",
     "side": "A",
     "mx": 24.7,
     "my": 44.5,
     "name": "Cord cutter",
     "desc": "Protected notch that shears cord and zip ties without an exposed edge.",
     "sc": "Cutting a zip tie off luggage at the airport.",
     "n": 14,
     "est": false,
     "ph": {
      "A": {
       "x": 25.7,
       "y": 75.8
      }
     },
     "phOwn": true
    },
    {
     "cat": "CLEAN",
     "side": "B",
     "mx": 0,
     "my": 54.2,
     "name": "BBQ grill scraper",
     "desc": "Narrow scraper for between the bars.",
     "sc": "Getting into the grate corners a wide blade misses.",
     "n": 25,
     "est": false,
     "ph": {
      "B": {
       "x": 14.3,
       "y": 45
      }
     },
     "phOwn": true
    },
    {
     "cat": "DRIVE",
     "side": "A",
     "mx": 80.9,
     "my": 0,
     "name": "Flat screwdriver",
     "desc": "Second, narrower flat tip on the opposite edge.",
     "sc": "Small terminal screws on a plug.",
     "n": 27,
     "est": false,
     "ph": {
      "A": {
       "x": 64.3,
       "y": 20.4
      }
     },
     "phOwn": true
    },
    {
     "cat": "PRY",
     "side": "A",
     "mx": 84.1,
     "my": 3.3,
     "name": "Nail puller",
     "desc": "V-notch that grips a nail head for pulling.",
     "sc": "Pulling a proud nail out of a pallet.",
     "n": 28,
     "est": false,
     "ph": {
      "A": {
       "x": 67.6,
       "y": 22.5
      }
     },
     "phOwn": true
    },
    {
     "cat": "PRY",
     "side": "A",
     "mx": 85,
     "my": 6.6,
     "name": "Pry bar",
     "desc": "Thick lever end for lids, staples and stuck panels.",
     "sc": "Levering a paint lid open at the site.",
     "n": 29,
     "est": false,
     "ph": {
      "A": {
       "x": 70,
       "y": 25.8
      }
     },
     "phOwn": true
    },
    {
     "cat": "CLEAN",
     "side": "A",
     "mx": 85,
     "my": 30.8,
     "name": "Scraper",
     "desc": "Flat broad edge for paint, ice and hide.",
     "sc": "Scraping frost off a windscreen.",
     "n": 31,
     "est": false,
     "ph": {
      "A": {
       "x": 72.4,
       "y": 37
      }
     },
     "phOwn": true
    },
    {
     "cat": "DIG",
     "side": "A",
     "mx": 85,
     "my": 25.4,
     "name": "Shovel",
     "desc": "Scoop profile — lash it to a stick to dig.",
     "sc": "Digging a trench around the tent in rain.",
     "n": 32,
     "est": false,
     "ph": {
      "A": {
       "x": 74.1,
       "y": 42.9
      }
     },
     "phOwn": true
    },
    {
     "cat": "CHOP",
     "side": "A",
     "mx": 85,
     "my": 36.5,
     "name": "Semi-sharp hatchet",
     "desc": "Blunt chopping edge — splits kindling, stays legal in a wallet.",
     "sc": "Splitting kindling at a campsite.",
     "n": 35,
     "est": false,
     "ph": {
      "A": {
       "x": 75.3,
       "y": 48.7
      }
     },
     "phOwn": true
    },
    {
     "cat": "OPEN",
     "side": "A",
     "mx": 83.8,
     "my": 50.6,
     "name": "Box opener",
     "desc": "Shielded hook that slits tape without touching the contents.",
     "sc": "Opening a parcel without slicing the goods inside.",
     "n": 39,
     "est": false,
     "ph": {
      "A": {
       "x": 78.2,
       "y": 73.5
      }
     },
     "phOwn": true
    },
    {
     "cat": "OPEN",
     "side": "B",
     "mx": 65.1,
     "my": 50,
     "name": "Bottle opener",
     "desc": "Lever notch for crown caps.",
     "sc": "A bottle at a picnic with no opener.",
     "n": 55,
     "est": false,
     "ph": {
      "B": {
       "x": 50.5,
       "y": 68.3
      }
     },
     "phOwn": true
    },
    {
     "cat": "SHAPE",
     "side": "B",
     "mx": 42.1,
     "my": 55,
     "name": "Rasp",
     "desc": "Toothed edge for wood, plastic and nail work.",
     "sc": "Knocking a burr off a cut edge.",
     "n": 57,
     "est": false,
     "ph": {
      "B": {
       "x": 35.8,
       "y": 65.1
      }
     },
     "phOwn": true
    }
   ]
  },
  {
   "id": "wrench",
   "label": "Wrench & drive",
   "sub": "Nuts, bolts, valves, bits",
   "tools": [
    {
     "cat": "WRENCH",
     "side": "A",
     "mx": 32.8,
     "my": 9.6,
     "name": "Wrenches 5/16\", 3/8\", 1/2\"",
     "desc": "Imperial run, with the 1/2\" as a closed wrench rather than an open jaw — it grips a rounded nut that an open jaw would slip off.",
     "sc": "A rounded 1/2\" nut on a trailer hitch that no open spanner will hold.",
     "n": 4,
     "est": false,
     "ph": {
      "A": {
       "x": 34.9,
       "y": 34.6
      }
     },
     "phOwn": true
    },
    {
     "cat": "WRENCH",
     "side": "A",
     "mx": 47.6,
     "my": 8.9,
     "name": "Wrenches 9, 10, 11, 12 mm",
     "desc": "The metric sizes you actually meet on bikes, drones and flat-pack furniture.",
     "sc": "Loose M6 on a rack in a car park.",
     "n": 5,
     "est": false,
     "ph": {
      "A": {
       "x": 43.3,
       "y": 35
      }
     },
     "phOwn": true
    },
    {
     "cat": "DRIVE",
     "side": "A",
     "mx": 0,
     "my": 7.1,
     "name": "Ultrawide screwdriver",
     "desc": "Extra-wide flat tip for oversized slot screws and battery covers.",
     "sc": "Machine-panel screws too wide for any pocket driver.",
     "n": 7,
     "est": false,
     "ph": {
      "A": {
       "x": 2.7,
       "y": 39.4
      }
     },
     "phOwn": true
    },
    {
     "cat": "WRENCH",
     "side": "A",
     "mx": 34.3,
     "my": 23.5,
     "name": "Wrenches 9/16\", 10/16\", 13 mm, 15 mm",
     "desc": "The larger run — imperial and metric side by side.",
     "sc": "A 13 mm bolt on a bike rack, no toolbox in the boot.",
     "n": 8,
     "est": false,
     "ph": {
      "A": {
       "x": 27.2,
       "y": 49.7
      }
     },
     "phOwn": true
    },
    {
     "cat": "WRENCH",
     "side": "A",
     "mx": 24.3,
     "my": 29.5,
     "name": "1/2\" gas valve wrench",
     "desc": "Sized for the square stem of a domestic gas valve.",
     "sc": "Shutting off a gas line before a stove swap.",
     "n": 9,
     "est": false,
     "ph": {
      "A": {
       "x": 35,
       "y": 54.6
      }
     },
     "phOwn": true
    },
    {
     "cat": "WRENCH",
     "side": "B",
     "mx": 49.2,
     "my": 7,
     "name": "Butterfly wrench",
     "desc": "Wing-nut cutout for butterfly and thumb nuts.",
     "sc": "Tightening a butterfly nut on a bike seat post.",
     "n": 15,
     "est": false,
     "ph": {
      "B": {
       "x": 53.9,
       "y": 30.7
      }
     }
    },
    {
     "cat": "WRENCH",
     "side": "B",
     "mx": 17.2,
     "my": 38.5,
     "name": "O₂ gas wrench",
     "desc": "Cutout for oxygen bottle fittings.",
     "sc": "Opening an O₂ regulator on a welding set.",
     "n": 21,
     "est": false,
     "ph": {
      "B": {
       "x": 26.2,
       "y": 40.5
      }
     },
     "phOwn": true
    },
    {
     "cat": "WRENCH",
     "side": "A",
     "mx": 60.1,
     "my": 42.4,
     "name": "Acetylene wrench",
     "desc": "Cutout for acetylene bottle and torch fittings.",
     "sc": "Opening an acetylene valve on a welding rig.",
     "n": 34,
     "est": false,
     "ph": {
      "A": {
       "x": 65.1,
       "y": 51.2
      }
     },
     "phOwn": true
    },
    {
     "cat": "WRENCH",
     "side": "A",
     "mx": 69.2,
     "my": 38.5,
     "name": "Wrenches 6, 7 mm",
     "desc": "The small metric pair.",
     "sc": "A 6 mm nut on a drone arm.",
     "n": 36,
     "est": false,
     "ph": {
      "A": {
       "x": 62.4,
       "y": 58.9
      }
     },
     "phOwn": true
    },
    {
     "cat": "WRENCH",
     "side": "A",
     "mx": 59.8,
     "my": 55,
     "name": "Spoke wrenches",
     "desc": "Slots for common spoke nipple sizes.",
     "sc": "Truing a wheel on the road.",
     "n": 40,
     "est": false,
     "ph": {
      "A": {
       "x": 65.3,
       "y": 81
      }
     },
     "phOwn": true
    },
    {
     "cat": "DRIVE",
     "side": "B",
     "mx": 71.5,
     "my": 8.4,
     "name": "1/4\" hex bit driver",
     "desc": "Holds standard 1/4\" hex bits.",
     "sc": "Driving a wood screw with a bit from the toolbox.",
     "n": 45,
     "est": false,
     "ph": {
      "B": {
       "x": 66.2,
       "y": 39
      }
     },
     "phOwn": true
    },
    {
     "cat": "DRIVE",
     "side": "B",
     "mx": 78,
     "my": 7.2,
     "name": "4 mm CRV bit driver",
     "desc": "Holds 4 mm CRV precision bits.",
     "sc": "Electronics screws on a laptop hatch.",
     "n": 46,
     "est": false,
     "ph": {
      "B": {
       "x": 72.5,
       "y": 41.1
      }
     },
     "phOwn": true
    },
    {
     "cat": "DRIVE",
     "side": "B",
     "mx": 76.2,
     "my": 12.1,
     "name": "Leatherman standard bit driver",
     "desc": "Takes the flat Leatherman-standard bits — 4 mm and 1/8\" — and locks them so they cannot wobble out under torque.",
     "sc": "Torquing a hinge screw with the card as the handle.",
     "n": 47,
     "est": false,
     "ph": {
      "B": {
       "x": 67.8,
       "y": 48.5
      }
     },
     "phOwn": true
    },
    {
     "cat": "WRENCH",
     "side": "B",
     "mx": 76.5,
     "my": 40.8,
     "name": "Wrenches 2.5, 3 mm, 3/16\", 5, 5.5 mm",
     "desc": "The fine run for small hardware.",
     "sc": "A 3 mm nut on a model chassis.",
     "n": 52,
     "est": false,
     "ph": {
      "B": {
       "x": 57.3,
       "y": 66.5
      }
     },
     "phOwn": true
    },
    {
     "cat": "WRENCH",
     "side": "B",
     "mx": 65.7,
     "my": 48.8,
     "name": "Wrenches 8 mm, 5/16\"",
     "desc": "Open jaws for the two common mid sizes.",
     "sc": "An 8 mm nut on a scooter mirror.",
     "n": 56,
     "est": false,
     "ph": {
      "B": {
       "x": 51,
       "y": 69
      }
     }
    }
   ]
  },
  {
   "id": "field",
   "label": "Field & navigate",
   "sub": "Sun, moon, wire, edge care",
   "tools": [
    {
     "cat": "FIELD",
     "side": "B",
     "mx": 0,
     "my": 11.7,
     "name": "SOS signal",
     "desc": "Morse SOS reference engraved on the card.",
     "sc": "Signalling with a torch when the phone is dead.",
     "n": 17,
     "est": false,
     "ph": {
      "B": {
       "x": 28,
       "y": 13.5
      }
     },
     "phOwn": true
    },
    {
     "cat": "FIELD",
     "side": "B",
     "mx": 20.2,
     "my": 17.7,
     "name": "Wire bender holes",
     "desc": "A row of holes in different diameters — feed the wire in and bend it to a clean, repeatable angle.",
     "sc": "Bending a wire hook to hang a lamp in a tent.",
     "n": 18,
     "est": false,
     "ph": {
      "B": {
       "x": 35.2,
       "y": 26.7
      }
     },
     "phOwn": true
    },
    {
     "cat": "FIELD",
     "side": "B",
     "mx": 0,
     "my": 33.7,
     "name": "Plumb bob",
     "desc": "Hang the card on a cord and the edge gives you true vertical.",
     "sc": "Checking a fence post is upright with no level to hand.",
     "n": 19,
     "est": false,
     "ph": {
      "B": {
       "x": 20.7,
       "y": 26.9
      }
     },
     "phOwn": true
    },
    {
     "cat": "NAVIGATE",
     "side": "B",
     "mx": 4.5,
     "my": 51.4,
     "name": "Sundial clock",
     "desc": "Gnomon slot and hour lines — the sun gives you the time.",
     "sc": "Telling the time on a ridge with a flat battery.",
     "n": 23,
     "est": false,
     "ph": {
      "B": {
       "x": 15.3,
       "y": 45.4
      }
     },
     "phOwn": true
    },
    {
     "cat": "NAVIGATE",
     "side": "B",
     "mx": 8.4,
     "my": 13.8,
     "name": "Sundial compass",
     "desc": "The same dial read the other way round: the sun gives you north.",
     "sc": "Finding north at midday without a magnetic compass.",
     "n": 24,
     "est": false,
     "ph": {
      "B": {
       "x": 31,
       "y": 19.1
      }
     }
    },
    {
     "cat": "NAVIGATE",
     "side": "A",
     "mx": 48.8,
     "my": 55,
     "name": "Moon phase calendar",
     "desc": "Dial for reading the moon phase by date.",
     "sc": "Planning a night hike around moonlight.",
     "n": 41,
     "est": false,
     "ph": {
      "A": {
       "x": 48.1,
       "y": 80.8
      }
     },
     "phOwn": true
    },
    {
     "cat": "FIELD",
     "side": "A",
     "mx": 30.3,
     "my": 55,
     "name": "Sharpening angle guide",
     "desc": "Reference angles for setting a blade against a stone.",
     "sc": "Getting the bevel angle right on a kitchen knife.",
     "n": 42,
     "est": false,
     "ph": {
      "A": {
       "x": 33.9,
       "y": 83
      }
     },
     "phOwn": true
    },
    {
     "cat": "FIELD",
     "side": "A",
     "mx": 36.1,
     "my": 55,
     "name": "Knife sharpener",
     "desc": "Carbide notch for a quick edge touch-up.",
     "sc": "Bringing a dulled blade back mid-trip.",
     "n": 43,
     "est": false,
     "ph": {
      "A": {
       "x": 38.9,
       "y": 82.4
      }
     },
     "phOwn": true
    },
    {
     "cat": "FIELD",
     "side": "B",
     "mx": 45.5,
     "my": 8.5,
     "name": "Loops carabiner",
     "desc": "Slot pair that clips the card to a loop or ring.",
     "sc": "Clipping the card to a belt loop for the day.",
     "n": 48,
     "est": false,
     "ph": {
      "B": {
       "x": 51.7,
       "y": 30.2
      }
     }
    },
    {
     "cat": "NAVIGATE",
     "side": "B",
     "mx": 40.9,
     "my": 28.8,
     "name": "Military distance ruler",
     "desc": "Mil-style ranging scale — reads distance by apparent size, no metric ticks involved.",
     "sc": "Estimating range to a ridge line on a map exercise.",
     "n": 49,
     "est": false,
     "ph": {
      "B": {
       "x": 40.3,
       "y": 43.1
      }
     },
     "phOwn": true
    },
    {
     "cat": "CUT",
     "side": "B",
     "mx": 46.5,
     "my": 42.3,
     "name": "Wire stripper",
     "desc": "Notch that strips insulation without nicking the core.",
     "sc": "Stripping a lamp cord for a new plug.",
     "n": 51,
     "est": false,
     "ph": {
      "B": {
       "x": 44.3,
       "y": 57
      }
     },
     "phOwn": true
    },
    {
     "cat": "MEASURE",
     "side": "B",
     "mx": 85,
     "my": 50.5,
     "name": "Tyre thread depth guide",
     "desc": "Stepped tabs that read tread depth in the legal range.",
     "sc": "Checking tread before a long drive.",
     "n": 54,
     "est": false,
     "ph": {
      "B": {
       "x": 59.6,
       "y": 80.1
      }
     },
     "phOwn": true
    }
   ]
  },
  {
   "id": "measure",
   "label": "Measure & draw",
   "sub": "Rulers, gauges, angles, circles",
   "tools": [
    {
     "cat": "MEASURE",
     "side": "A",
     "mx": 33.6,
     "my": 0,
     "name": "Inch ruler",
     "desc": "Full inch scale down the long edge, quarter-inch ticks.",
     "sc": "Checking a shelf gap in a hardware aisle.",
     "n": 2,
     "est": false,
     "ph": {
      "A": {
       "x": 32.7,
       "y": 25
      }
     }
    },
    {
     "cat": "DRAW",
     "side": "A",
     "mx": 25.7,
     "my": 22.3,
     "name": "Quick angle 30° / 45° / 60°",
     "desc": "Three cut corners that give the common angles without a protractor.",
     "sc": "Marking a 45° mitre on trim with nothing but the card.",
     "n": 3,
     "est": false,
     "ph": {
      "A": {
       "x": 22.6,
       "y": 51
      }
     },
     "phOwn": true
    },
    {
     "cat": "MEASURE",
     "side": "A",
     "mx": 0,
     "my": 0,
     "name": "Inch L-square",
     "desc": "Square corner with inch graduations on both legs.",
     "sc": "Squaring a cut on a plank at the timber yard.",
     "n": 6,
     "est": false,
     "ph": {
      "A": {
       "x": 2.3,
       "y": 29.6
      }
     }
    },
    {
     "cat": "MEASURE",
     "side": "A",
     "mx": 46.1,
     "my": 42.1,
     "name": "Inch drill guide",
     "desc": "Stepped holes for sizing imperial bits and screws.",
     "sc": "Matching a wood screw to the right bit on site.",
     "n": 10,
     "est": false,
     "ph": {
      "A": {
       "x": 46,
       "y": 66.7
      }
     },
     "phOwn": true
    },
    {
     "cat": "DRAW",
     "side": "B",
     "mx": 27.1,
     "my": 10.3,
     "name": "Circle template",
     "desc": "Graded holes for drawing circles and checking rod diameters.",
     "sc": "Marking a hole for a cable pass-through.",
     "n": 16,
     "est": false,
     "ph": {
      "B": {
       "x": 40,
       "y": 26.3
      }
     },
     "phOwn": true
    },
    {
     "cat": "DRAW",
     "side": "B",
     "mx": 14.7,
     "my": 8.7,
     "name": "Metric compass",
     "desc": "Pivot and scale for circles up to 100 mm diameter.",
     "sc": "Drawing a 80 mm circle on a repair patch.",
     "n": 20,
     "est": false,
     "ph": {
      "B": {
       "x": 30.5,
       "y": 62.2
      }
     },
     "phOwn": true
    },
    {
     "cat": "DRAW",
     "side": "B",
     "mx": 32.8,
     "my": 55,
     "name": "Inch compass",
     "desc": "Same pivot, imperial scale.",
     "sc": "Scribing a 3\" arc on a plywood offcut.",
     "n": 22,
     "est": false,
     "ph": {
      "B": {
       "x": 22,
       "y": 17.6
      }
     },
     "phOwn": true
    },
    {
     "cat": "MEASURE",
     "side": "B",
     "mx": 42.4,
     "my": 55,
     "name": "Guitar string ruler",
     "desc": "Gauge slots for common string diameters.",
     "sc": "Matching a broken string backstage.",
     "n": 26,
     "est": false,
     "ph": {
      "B": {
       "x": 36.4,
       "y": 66.8
      }
     },
     "phOwn": true
    },
    {
     "cat": "MEASURE",
     "side": "A",
     "mx": 85,
     "my": 13.4,
     "name": "Precision ruler",
     "desc": "Fine graduation strip for close work.",
     "sc": "Measuring a 2 mm gasket to order the right size.",
     "n": 30,
     "est": false,
     "ph": {
      "A": {
       "x": 71.1,
       "y": 35.3
      }
     },
     "phOwn": true
    },
    {
     "cat": "DRAW",
     "side": "A",
     "mx": 64.3,
     "my": 27.3,
     "name": "Protractor",
     "desc": "Full angle scale around the arc.",
     "sc": "Setting a 30° angle on a workbench jig.",
     "n": 33,
     "est": false,
     "ph": {
      "A": {
       "x": 57.5,
       "y": 51.2
      }
     },
     "phOwn": true
    },
    {
     "cat": "MEASURE",
     "side": "A",
     "mx": 68.4,
     "my": 42.1,
     "name": "Sheet thickness gauge",
     "desc": "Stepped slots for gauging sheet metal and plastic.",
     "sc": "Checking sheet gauge before ordering a replacement panel.",
     "n": 37,
     "est": false,
     "ph": {
      "A": {
       "x": 64,
       "y": 63
      }
     },
     "phOwn": true
    },
    {
     "cat": "DRAW",
     "side": "A",
     "mx": 76.9,
     "my": 52.1,
     "name": "Parallel guide",
     "desc": "Notch run for stepping off parallel lines.",
     "sc": "Drawing a border 10 mm in from an edge.",
     "n": 38,
     "est": false,
     "ph": {
      "A": {
       "x": 73.9,
       "y": 73.4
      }
     },
     "phOwn": true
    },
    {
     "cat": "MEASURE",
     "side": "B",
     "mx": 52.7,
     "my": 0,
     "name": "Metric ruler",
     "desc": "Millimetre scale along the back edge.",
     "sc": "Measuring a bolt length in mm.",
     "n": 44,
     "est": false,
     "ph": {
      "B": {
       "x": 58,
       "y": 24.2
      }
     }
    },
    {
     "cat": "MEASURE",
     "side": "B",
     "mx": 37.2,
     "my": 43.3,
     "name": "Metric drill guide",
     "desc": "Stepped holes for metric bits and rod.",
     "sc": "Sizing a metric bit for a wall plug.",
     "n": 50,
     "est": false,
     "ph": {
      "B": {
       "x": 38.4,
       "y": 53
      }
     },
     "phOwn": true
    },
    {
     "cat": "DRAW",
     "side": "B",
     "mx": 82.1,
     "my": 45.3,
     "name": "Precision protractor",
     "desc": "Fine-degree arc for accurate angle work.",
     "sc": "Transferring a 22° angle onto a workpiece.",
     "n": 53,
     "est": false,
     "ph": {
      "B": {
       "x": 63.1,
       "y": 76.4
      }
     }
    }
   ]
  }
 ],
 "hom": {
  "A": [[0.012488786033316372, -0.0013031284837266765, -0.08757248270080625], [0.0019772693141873656, 0.015080028511728173, -0.2850064738923416], [-0.0008840479038004208, 0.0016690714753305387, 0.9782300476898965]],
  "B": [[0.01391750102142808, 0.005816789393711031, -0.3240073389710713], [-0.012784438662954362, 0.0160231640330383, 0.2530572910466476], [-0.0011454819433162385, -0.00042361187768993197, 1.0265524457832214]]
 },
 "card": {
  "w": 85,
  "h": 55,
  "t": 2.4
 },
 "homApprox": {
  "A": true,
  "B": true
 }
};
